import { render, staticRenderFns } from "./deliveryPoints.vue?vue&type=template&id=472b6d04&"
import script from "./deliveryPoints.vue?vue&type=script&lang=js&"
export * from "./deliveryPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports